import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    overflow: 'hidden',
    maxHeight: '100vh',
    background: 'url("/assets/images/backgrounds/background_image.webp") no-repeat ',
    backgroundSize: 'cover',
  },
  
  sideTriangle: {
    zIndex: 0,
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '0', 
    height: '0',
    borderLeft: `52rem solid ${Colors.loginPrimaryColor}`,
    borderTop: `80vh solid transparent`,
  },
  
  aside: {
    display: 'flex',
    flexDirection: 'column',
    width: '30%',
    justifyContent: 'space-between',
    padding: 40,
    color: theme.palette.primary.lighter,
    zIndex: 1,
  },
  logo: {
    width: 300,

    [theme.breakpoints.down('md')]: {
      width: 230,
    },
  },
  title: {
    color: Colors.titleColor,
    fontSize: 30,
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
    width: 'fit-content',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '60px 100px',
    backgroundColor: `${Colors.transparentFormColor}`,
    backdropFilter: 'blur(3px)',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    width: 300,
    marginBottom: 30,
    '& input':{
      color: `${Colors.primaryTextColor}`,
      padding: '6px',
    },
    '& input:-webkit-autofill ': {
      '-webkit-background-clip': 'text',
    },
    '& label':{
      color: `${Colors.primaryTextColor}`,
    },
  },
  
  button: {
    width: 300,
    height: 50,
    borderRadius: 30,
    marginTop: 50,
    marginBottom: 20,
    transition: 'all 200ms ease-in-out',
    backgroundColor: `${Colors.loginPrimaryColor}`,
    '&:hover': {
      backgroundColor: `${Colors.loginDarkenPrimaryColor}`,
    },
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  progress: {
    height: '25px !important',
    margin: theme.spacing(1),
    width: '25px !important',
  },
  noDisplay: {
    display: 'none',
  },
  
  link: {
    '& a': {
      textDecoration: 'none',
      color: Colors.loginPrimaryColor,
      '&:visited ': {
        color: Colors.loginPrimaryColor,
      },
      '&:hover': {
        textDecoration: 'underline',
      },
      '&:active': {
        textDecoration: 'underline',
      },
    },
  },
}))

export default styles
